import { colors, fonts } from 'components/styles/variables';
import selectedCheckIcon from 'public/static/images/srp/selectedCheck.svg';

export default `
  .radius-modal {
    border-radius: 8px;
    width: 114px;
    justify-content: center;
    padding: 8px 0;
    list-style: none;
    margin: 0;
  }

  .sort-by-modal {
    border-radius: 8px;
    width: 274px;
    padding: 8px 0;
    list-style: none;
    margin: 0;
  }

  .fuel-efficiency-modal {
    border-radius: 8px;
    padding: 8px 0;
    list-style: none;
    margin: 0;
  }

  .check-menu-list-modal {
    border-radius: 8px;
    padding: 8px 0;
    list-style: none;
    margin: 0;
    position: relative;
  }

  .list-item {
    cursor: pointer;
    font-family: ${fonts.default};
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${colors.BLACK};
    display: flex;
    align-items: center;
    padding: 12px 24px;
    background-color: ${colors.WHITE};
  }

  .list-item:hover {
    background-color: ${colors.G1};
  }

  .selected {
    background-color: ${colors.WHITE};
    color: ${colors.ALR1};
  }

  .selected-icon {
    background-image: url(${selectedCheckIcon});
    width: 14px;
    height: 9px;
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    left: 7px;
  }

  .zero-facets {
    color: ${colors.G2};
    cursor: not-allowed;
  }
`;
